var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "h-100 w-100" }, [
    _c(
      "nav",
      {
        staticClass:
          "navbar navbar-light sticky-top bg-light flex-md-nowrap px-0 py-2 shadow d-block d-md-none",
        attrs: { type: "light" }
      },
      [
        _c(
          "button",
          {
            staticClass: "navbar-toggler position-absolute d-md-none",
            attrs: {
              type: "button",
              "data-toggle": "collapse",
              "data-target": "#sidebarMenu",
              "aria-controls": "sidebarMenu",
              "aria-expanded": "false",
              "aria-label": "Toggle navigation"
            },
            on: { click: () => _vm.collapse() }
          },
          [_c("span", { staticClass: "navbar-toggler-icon" })]
        ),
        _vm._v(" "),
        _c("ul", { staticClass: "navbar-nav px-3" }, [
          _c("li", { staticClass: "nav-item text-nowrap" }, [
            _c("a", { staticClass: "nav-link", attrs: { href: "/logout" } }, [
              _vm.state.currentUser
                ? _c("span", [_vm._v(_vm._s(_vm.state.currentUser) + " -")])
                : _vm._e(),
              _vm._v(" Sair\n        ")
            ])
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "container-fluid h-100" }, [
      _c(
        "div",
        { staticClass: "row m-0 w-100 h-100" },
        [
          _c(
            "nav",
            {
              staticClass: "col d-md-block bg-light sidebar",
              class: { collapse: _vm.state.collapsed },
              attrs: { id: "sidebarMenu" }
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "sidebar-sticky pt-5 pt-md-1 h-100 d-flex justify-content-between flex-column"
                },
                [
                  _c("ul", { staticClass: "nav flex-column mt-4 mt-md-1" }, [
                    _c("div", [
                      _vm.hasPermissionToAccess(
                        _vm.state.userData.profile,
                        "Dashboard"
                      )
                        ? _c("li", { staticClass: "nav-item" }, [
                            _c(
                              "a",
                              {
                                staticClass: "nav-link",
                                class: {
                                  active: _vm.isMenuActive("/dashboard")
                                },
                                attrs: { href: "/#/dashboard" },
                                on: { click: this.setCollapsed }
                              },
                              [
                                _c("b-icon-house"),
                                _vm._v(" Home\n                  "),
                                _c("span", { staticClass: "sr-only" }, [
                                  _vm._v("(current)")
                                ])
                              ],
                              1
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermissionToAccess(
                        _vm.state.userData.profile,
                        "Users"
                      )
                        ? _c("li", { staticClass: "nav-item" }, [
                            _c(
                              "a",
                              {
                                staticClass: "nav-link",
                                class: { active: _vm.isMenuActive("/users") },
                                attrs: { href: "/#/users" },
                                on: { click: this.setCollapsed }
                              },
                              [
                                _c("b-icon-people"),
                                _vm._v(" Usuários\n                  "),
                                _c("span", { staticClass: "sr-only" }, [
                                  _vm._v("(current)")
                                ])
                              ],
                              1
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermissionToAccess(
                        _vm.state.userData.profile,
                        "Installation"
                      )
                        ? _c("div", [
                            _vm._m(0),
                            _vm._v(" "),
                            _c("li", { staticClass: "nav-item" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "nav-link",
                                  class: {
                                    active: _vm.isMenuActive("/installation")
                                  },
                                  attrs: { href: "/#/installation" },
                                  on: { click: this.setCollapsed }
                                },
                                [
                                  _c("b-icon-bullseye"),
                                  _vm._v(" Instalações\n                    "),
                                  _c("span", { staticClass: "sr-only" }, [
                                    _vm._v("(current)")
                                  ])
                                ],
                                1
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermissionToAccess(
                        _vm.state.userData.profile,
                        "Panorama"
                      )
                        ? _c("li", { staticClass: "nav-item" }, [
                            _c(
                              "a",
                              {
                                staticClass: "nav-link",
                                class: {
                                  active: _vm.isMenuActive("/panorama")
                                },
                                attrs: { href: "/#/panorama" },
                                on: { click: this.setCollapsed }
                              },
                              [
                                _c("b-icon-bullseye"),
                                _vm._v(" Panorama\n                  "),
                                _c("span", { staticClass: "sr-only" }, [
                                  _vm._v("(current)")
                                ])
                              ],
                              1
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermissionToAccess(
                        _vm.state.userData.profile,
                        "Panorama"
                      )
                        ? _c("li", { staticClass: "nav-item" }, [
                            _c(
                              "a",
                              {
                                staticClass: "nav-link",
                                class: {
                                  active: _vm.isMenuActive("/new-panorama")
                                },
                                attrs: { href: "/#/new-panorama" },
                                on: { click: this.setCollapsed }
                              },
                              [
                                _c("b-icon-bullseye"),
                                _vm._v(" Novo Panorama\n                  "),
                                _c("span", { staticClass: "sr-only" }, [
                                  _vm._v("(current)")
                                ])
                              ],
                              1
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermissionToAccess(
                        _vm.state.userData.profile,
                        "PanoramaCustom"
                      )
                        ? _c("li", { staticClass: "nav-item" }, [
                            _c(
                              "a",
                              {
                                staticClass: "nav-link",
                                class: {
                                  active: _vm.isMenuActive("/panorama-custom")
                                },
                                attrs: { href: "/#/panorama-custom" },
                                on: { click: this.setCollapsed }
                              },
                              [
                                _c("b-icon-bullseye"),
                                _vm._v(" Panorama Custom\n                  "),
                                _c("span", { staticClass: "sr-only" }, [
                                  _vm._v("(current)")
                                ])
                              ],
                              1
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermissionToAccess(
                        _vm.state.userData.profile,
                        "Billing"
                      )
                        ? _c("li", { staticClass: "nav-item" }, [
                            _c(
                              "a",
                              {
                                staticClass: "nav-link",
                                class: { active: _vm.isMenuActive("/billing") },
                                attrs: { href: "/#/billing" },
                                on: { click: this.setCollapsed }
                              },
                              [
                                _c("b-icon-cash-stack"),
                                _vm._v(" Faturamento\n                  "),
                                _c("span", { staticClass: "sr-only" }, [
                                  _vm._v("(current)")
                                ])
                              ],
                              1
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermissionToAccess(
                        _vm.state.userData.profile,
                        "OverdueInvoice"
                      )
                        ? _c("li", { staticClass: "nav-item" }, [
                            _c(
                              "a",
                              {
                                staticClass: "nav-link",
                                class: {
                                  active: _vm.isMenuActive("/overdue-invoice")
                                },
                                attrs: { href: "/#/overdue-invoice" },
                                on: { click: this.setCollapsed }
                              },
                              [
                                _c("b-icon-cash-stack"),
                                _vm._v(
                                  " Faturas\n                  Atrasadas\n                  "
                                ),
                                _c("span", { staticClass: "sr-only" }, [
                                  _vm._v("(current)")
                                ])
                              ],
                              1
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermissionToAccess(
                        _vm.state.userData.profile,
                        "Coupons"
                      )
                        ? _c("div", [
                            _vm._m(1),
                            _vm._v(" "),
                            _c("li", { staticClass: "nav-item" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "nav-link",
                                  class: {
                                    active: _vm.isMenuActive("/coupons")
                                  },
                                  attrs: { href: "/#/coupons" },
                                  on: { click: this.setCollapsed }
                                },
                                [
                                  _c("b-icon-wallet2"),
                                  _vm._v(" Cupom\n                    "),
                                  _c("span", { staticClass: "sr-only" }, [
                                    _vm._v("(current)")
                                  ])
                                ],
                                1
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermissionToAccess(
                        _vm.state.userData.profile,
                        "Commissions"
                      )
                        ? _c("li", { staticClass: "nav-item" }, [
                            _c(
                              "a",
                              {
                                staticClass: "nav-link",
                                class: {
                                  active: _vm.isMenuActive("/commission")
                                },
                                attrs: { href: "/#/commission" },
                                on: { click: this.setCollapsed }
                              },
                              [
                                _c("b-icon-cash-stack"),
                                _vm._v(" Comissões\n                  "),
                                _c("span", { staticClass: "sr-only" }, [
                                  _vm._v("(current)")
                                ])
                              ],
                              1
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", [
                        _vm._m(2),
                        _vm._v(" "),
                        _vm.hasPermissionToAccess(
                          _vm.state.userData.profile,
                          "LeadsExtract"
                        )
                          ? _c("li", { staticClass: "nav-item" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "nav-link",
                                  class: {
                                    active: _vm.isMenuActive("/leads-extract")
                                  },
                                  attrs: { href: "/#/leads-extract" },
                                  on: { click: this.setCollapsed }
                                },
                                [
                                  _c("b-icon-building"),
                                  _vm._v(
                                    " Leads:extrair\n                    "
                                  ),
                                  _c("span", { staticClass: "sr-only" }, [
                                    _vm._v("(current)")
                                  ])
                                ],
                                1
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.hasPermissionToAccess(
                          _vm.state.userData.profile,
                          "Leads"
                        )
                          ? _c("li", { staticClass: "nav-item" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "nav-link",
                                  class: { active: _vm.isMenuActive("/leads") },
                                  attrs: { href: "/#/leads" },
                                  on: { click: this.setCollapsed }
                                },
                                [
                                  _c("b-icon-building"),
                                  _vm._v(" Leads\n                    "),
                                  _c("span", { staticClass: "sr-only" }, [
                                    _vm._v("(current)")
                                  ])
                                ],
                                1
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.hasPermissionToAccess(
                          _vm.state.userData.profile,
                          "LeadsQualified"
                        )
                          ? _c("li", { staticClass: "nav-item" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "nav-link",
                                  class: {
                                    active: _vm.isMenuActive("/qualified-leads")
                                  },
                                  attrs: { href: "/#/qualified-leads" },
                                  on: { click: this.setCollapsed }
                                },
                                [
                                  _c("b-icon-building"),
                                  _vm._v(
                                    " Leads\n                    qualificados\n                    "
                                  ),
                                  _c("span", { staticClass: "sr-only" }, [
                                    _vm._v("(current)")
                                  ])
                                ],
                                1
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.hasPermissionToAccess(
                          _vm.state.userData.profile,
                          "LeadsQualified"
                        )
                          ? _c("li", { staticClass: "nav-item" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "nav-link",
                                  class: {
                                    active: _vm.isMenuActive("/leads-report")
                                  },
                                  attrs: { href: "/#/leads-report" },
                                  on: { click: this.setCollapsed }
                                },
                                [
                                  _c("b-icon-building"),
                                  _vm._v(
                                    " Relatório de\n                    leads\n                    "
                                  ),
                                  _c("span", { staticClass: "sr-only" }, [
                                    _vm._v("(current)")
                                  ])
                                ],
                                1
                              )
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _vm.hasPermissionToAccess(
                        _vm.state.userData.profile,
                        "Investments"
                      )
                        ? _c("div", [
                            _vm._m(3),
                            _vm._v(" "),
                            _c("li", { staticClass: "nav-item" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "nav-link",
                                  class: {
                                    active: _vm.isMenuActive("/investments")
                                  },
                                  attrs: { href: "/#/investments" },
                                  on: { click: this.setCollapsed }
                                },
                                [
                                  _c("b-icon-bar-chart"),
                                  _vm._v(
                                    " Investimentos\n                    "
                                  ),
                                  _c("span", { staticClass: "sr-only" }, [
                                    _vm._v("(current)")
                                  ])
                                ],
                                1
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermissionToAccess(
                        _vm.state.userData.profile,
                        "PowerPlants"
                      )
                        ? _c("div", [
                            _vm._m(4),
                            _vm._v(" "),
                            _c("li", { staticClass: "nav-item" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "nav-link",
                                  class: {
                                    active: _vm.isMenuActive("/power-plants")
                                  },
                                  attrs: { href: "/#/power-plants" },
                                  on: { click: this.setCollapsed }
                                },
                                [
                                  _c("b-icon-lightning"),
                                  _vm._v(" Usinas\n                    "),
                                  _c("span", { staticClass: "sr-only" }, [
                                    _vm._v("(current)")
                                  ])
                                ],
                                1
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermissionToAccess(
                        _vm.state.userData.profile,
                        "Cooperatives"
                      )
                        ? _c("li", { staticClass: "nav-item" }, [
                            _c(
                              "a",
                              {
                                staticClass: "nav-link",
                                class: {
                                  active: _vm.isMenuActive("/cooperatives")
                                },
                                attrs: { href: "/#/cooperatives" },
                                on: { click: this.setCollapsed }
                              },
                              [
                                _c("b-icon-building"),
                                _vm._v(" Cooperativas\n                  "),
                                _c("span", { staticClass: "sr-only" }, [
                                  _vm._v("(current)")
                                ])
                              ],
                              1
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermissionToAccess(
                        _vm.state.userData.profile,
                        "Distributors"
                      )
                        ? _c("li", { staticClass: "nav-item" }, [
                            _c(
                              "a",
                              {
                                staticClass: "nav-link",
                                class: {
                                  active: _vm.isMenuActive("/distributors")
                                },
                                attrs: { href: "/#/distributors" },
                                on: { click: this.setCollapsed }
                              },
                              [
                                _c("b-icon-lightning-fill"),
                                _vm._v(" Distribuidoras\n                  "),
                                _c("span", { staticClass: "sr-only" }, [
                                  _vm._v("(current)")
                                ])
                              ],
                              1
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermissionToAccess(
                        _vm.state.userData.profile,
                        "Covenant"
                      )
                        ? _c("li", { staticClass: "nav-item" }, [
                            _c(
                              "a",
                              {
                                staticClass: "nav-link",
                                class: {
                                  active: _vm.isMenuActive("/covenant")
                                },
                                attrs: { href: "/#/covenant" },
                                on: { click: this.setCollapsed }
                              },
                              [
                                _c("b-icon-building"),
                                _vm._v(" Convênios\n                  "),
                                _c("span", { staticClass: "sr-only" }, [
                                  _vm._v("(current)")
                                ])
                              ],
                              1
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermissionToAccess(
                        _vm.state.userData.profile,
                        "Loggers"
                      )
                        ? _c("div", [
                            _vm._m(5),
                            _vm._v(" "),
                            _c("li", { staticClass: "nav-item" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "nav-link",
                                  class: {
                                    active: _vm.isMenuActive("/loggers")
                                  },
                                  attrs: { href: "/#/loggers" },
                                  on: { click: this.setCollapsed }
                                },
                                [
                                  _c("b-icon-archive"),
                                  _vm._v(" Logs\n                    "),
                                  _c("span", { staticClass: "sr-only" }, [
                                    _vm._v("(current)")
                                  ])
                                ],
                                1
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermissionToAccess(
                        _vm.state.userData.profile,
                        "Contracts"
                      )
                        ? _c("li", { staticClass: "nav-item" }, [
                            _c(
                              "a",
                              {
                                staticClass: "nav-link",
                                class: {
                                  active: _vm.isMenuActive("/contracts")
                                },
                                attrs: { href: "/#/contracts" },
                                on: { click: this.setCollapsed }
                              },
                              [
                                _c("b-icon-brush"),
                                _vm._v(" Contratos\n                  "),
                                _c("span", { staticClass: "sr-only" }, [
                                  _vm._v("(current)")
                                ])
                              ],
                              1
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermissionToAccess(
                        _vm.state.userData.profile,
                        "Faqs"
                      )
                        ? _c("li", { staticClass: "nav-item" }, [
                            _c(
                              "a",
                              {
                                staticClass: "nav-link",
                                class: { active: _vm.isMenuActive("/faq") },
                                attrs: { href: "/#/faqs" },
                                on: { click: this.setCollapsed }
                              },
                              [
                                _c("b-icon-list-check"),
                                _vm._v(" FAQ\n                  "),
                                _c("span", { staticClass: "sr-only" }, [
                                  _vm._v("(current)")
                                ])
                              ],
                              1
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermissionToAccess(
                        _vm.state.userData.profile,
                        "Notifications"
                      )
                        ? _c("li", { staticClass: "nav-item" }, [
                            _c(
                              "a",
                              {
                                staticClass: "nav-link",
                                class: {
                                  active: _vm.isMenuActive("/notification")
                                },
                                attrs: { href: "/#/notifications" },
                                on: { click: this.setCollapsed }
                              },
                              [
                                _c("b-icon-bell"),
                                _vm._v(" Notificações\n                  "),
                                _c("span", { staticClass: "sr-only" }, [
                                  _vm._v("(current)")
                                ])
                              ],
                              1
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermissionToAccess(
                        _vm.state.userData.profile,
                        "AdminUsers"
                      )
                        ? _c("div", [
                            _vm._m(6),
                            _vm._v(" "),
                            _c("li", { staticClass: "nav-item" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "nav-link",
                                  class: {
                                    active: _vm.isMenuActive("/admin-user")
                                  },
                                  attrs: { href: "/#/admin-users" },
                                  on: { click: this.setCollapsed }
                                },
                                [
                                  _c("b-icon-lock"),
                                  _vm._v(
                                    " Administradores\n                    "
                                  ),
                                  _c("span", { staticClass: "sr-only" }, [
                                    _vm._v("(current)")
                                  ])
                                ],
                                1
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermissionToAccess(
                        _vm.state.userData.profile,
                        "Consumers"
                      )
                        ? _c("li", { staticClass: "nav-item" }, [
                            _c(
                              "a",
                              {
                                staticClass: "nav-link",
                                class: {
                                  active: _vm.isMenuActive("/consumer")
                                },
                                attrs: { href: "/#/consumers" },
                                on: { click: this.setCollapsed }
                              },
                              [
                                _c("b-icon-cart"),
                                _vm._v(" Consumidores\n                  "),
                                _c("span", { staticClass: "sr-only" }, [
                                  _vm._v("(current)")
                                ])
                              ],
                              1
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermissionToAccess(
                        _vm.state.userData.profile,
                        "Traders"
                      )
                        ? _c("li", { staticClass: "nav-item" }, [
                            _c(
                              "a",
                              {
                                staticClass: "nav-link",
                                class: { active: _vm.isMenuActive("/trader") },
                                attrs: { href: "/#/traders" },
                                on: { click: this.setCollapsed }
                              },
                              [
                                _c("b-icon-briefcase"),
                                _vm._v(
                                  " Comercializadores\n                  "
                                ),
                                _c("span", { staticClass: "sr-only" }, [
                                  _vm._v("(current)")
                                ])
                              ],
                              1
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermissionToAccess(
                        _vm.state.userData.profile,
                        "Partners"
                      )
                        ? _c("li", { staticClass: "nav-item" }, [
                            _c(
                              "a",
                              {
                                staticClass: "nav-link",
                                class: { active: _vm.isMenuActive("/partner") },
                                attrs: { href: "/#/partners" },
                                on: { click: this.setCollapsed }
                              },
                              [
                                _c("b-icon-people"),
                                _vm._v(" Parceiros\n                  "),
                                _c("span", { staticClass: "sr-only" }, [
                                  _vm._v("(current)")
                                ])
                              ],
                              1
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermissionToAccess(
                        _vm.state.userData.profile,
                        "Investors"
                      )
                        ? _c("div", [
                            _c("li", { staticClass: "nav-item" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "nav-link",
                                  class: {
                                    active: _vm.isMenuActive("/investor")
                                  },
                                  attrs: { href: "/#/investors" },
                                  on: { click: this.setCollapsed }
                                },
                                [
                                  _c("b-icon-cash-stack"),
                                  _vm._v(" Investidores\n                    "),
                                  _c("span", { staticClass: "sr-only" }, [
                                    _vm._v("(current)")
                                  ])
                                ],
                                1
                              )
                            ])
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._m(7),
                    _vm._v(" "),
                    _c("div", { staticClass: "nav-item text-nowrap" }, [
                      _c(
                        "button",
                        {
                          staticClass: "nav-link btn-new-system",
                          attrs: { title: "Abrir no novo sistema" },
                          on: { click: _vm.goToNewSystem }
                        },
                        [
                          _c("b-icon-box-arrow-up-right", {
                            staticClass: "icon-new-system"
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Novo Sistema")])
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _vm._m(8),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "nav-item text-nowrap bottom-user" },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "nav-link",
                            attrs: { href: "/logout" }
                          },
                          [
                            _vm.state.currentUser
                              ? _c("span", [
                                  _vm._v(_vm._s(_vm.state.currentUser) + " -")
                                ])
                              : _vm._e(),
                            _vm._v("\n                Sair\n              ")
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm._m(9),
                    _vm._v(" "),
                    _c("img", {
                      staticClass: "navbar-brand logo-veins mr-0",
                      staticStyle: { width: "6em" },
                      attrs: { src: "/images/logo_veins.png", alt: "" }
                    })
                  ])
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c("router-view", { key: _vm.$route.fullPath })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", { staticClass: "nav-item" }, [
      _c("hr", { staticClass: "horizontal-separator" })
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", { staticClass: "nav-item" }, [
      _c("hr", { staticClass: "horizontal-separator" })
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", { staticClass: "nav-item" }, [
      _c("hr", { staticClass: "horizontal-separator" })
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", { staticClass: "nav-item" }, [
      _c("hr", { staticClass: "horizontal-separator" })
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", { staticClass: "nav-item" }, [
      _c("hr", { staticClass: "horizontal-separator" })
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", { staticClass: "nav-item" }, [
      _c("hr", { staticClass: "horizontal-separator" })
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", { staticClass: "nav-item" }, [
      _c("hr", { staticClass: "horizontal-separator" })
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "nav-item" }, [
      _c("hr", { staticClass: "horizontal-separator" })
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "nav-item" }, [
      _c("hr", { staticClass: "horizontal-separator" })
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "nav-item" }, [
      _c("hr", { staticClass: "horizontal-separator" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }